import React, {useState} from 'react';
import AggregateCard from '../card/aggregateCard';
import "./aggregationModalContainer.css";
import {Button} from '@mantine/core';
import {AggregationInfo, KpiProps} from "../../../../../../types/types";
import { themeProvider } from '../../../../../style/utils';

export type AggregateModalContainerProps = {
    aggregationList: AggregationInfo[],
    setOpened: (x: boolean) => void
}

type SelectableAggregationDetails = {
    aggregationName: string,
    description: string,
    isSelected: boolean
}

const AggregateModalContainer = (props: AggregateModalContainerProps & KpiProps) => {

    const [state, setState] = useState<SelectableAggregationDetails[]>(() => getInitialState());

    function getInitialState() {
        const array: SelectableAggregationDetails[] = [];
        props.aggregationList.forEach(item => {
            if (props.kpiInfo.aggregationNames.includes(item.aggregationName)) {
                array.unshift(toSelectableDetails(item, true))
            } else {
                array.push(toSelectableDetails(item))
            }
        })
        return array;
    }

    function toSelectableDetails(item: AggregationInfo, isSelected = false): SelectableAggregationDetails {
        return {
            aggregationName: item.aggregationName,
            description: item.description,
            isSelected: isSelected
        }
    }

    function onToggle(name: string, flag: boolean) {
        const newState: SelectableAggregationDetails[] = state.map(item => item.aggregationName === name ? {
            ...item,
            isSelected: flag
        } : item)
        setState(newState);
    }

    function onButtonClick() {
        const aggregations = state.filter(i => i.isSelected).map( i => i.aggregationName);
        props.setKpiInfo({...props.kpiInfo, aggregationNames: aggregations})
        props.setOpened(false);
    }

    return <div>
        <div className="aggregation-container">
            {state && state.map(i => <AggregateCard onToggle={onToggle} selected={i.isSelected} {...props}
                                                    key={i.aggregationName} name={i.aggregationName}
                                                    description={i.description}/>)}
        </div>
        <div className="aggregation-container-submitButton">
            <Button sx={themeProvider} color="teal" variant="outline" onClick={onButtonClick}>Apply</Button>
        </div>
    </div>
}

export default AggregateModalContainer;